<template>
    <div>
        <router-view v-bind="$attrs"></router-view>
    </div>
</template>

<script>
    export default {
        name: 'BaseRouterView'
    }
</script>
